export default __webpack_public_path__ + "static/building-176927bcf5b56e7f368f1d78cd6cd43c.jpg";